import { FC } from 'react'

import LogisticProvider from '@provider/Kpi/LogisticProvider'
import RuptureProvider from '@provider/Kpi/RuptureProvider'
import SalesProvider from '@provider/Kpi/SalesProvider'
import StorageProvider from '@provider/Kpi/StorageProvider'

const KpiProviders: FC = ({ children }) => {
  return (
    <RuptureProvider>
      <LogisticProvider>
        <StorageProvider>
          <SalesProvider>{children}</SalesProvider>
        </StorageProvider>
      </LogisticProvider>
    </RuptureProvider>
  )
}

export default KpiProviders
